import { TaskResource } from "../../../../client/resources/taskResource";
import { DeploymentResource } from "../../../../client/resources/deploymentResource";
import { Filter, getQuery } from "areas/tasks/components/Tasks/Tasks";
import { convertQueryToQueryString } from "components/QueryStringFilters/QueryStringFilters";
import { session } from "../../../../clientInstance";
import { Permission } from "../../../../client/resources";

export default (root: string) => {
    const taskRoot = `${root}/tasks`;
    function filteredTasks(tasksFilter: Filter) {
        const queryString = convertQueryToQueryString(getQuery(tasksFilter));
        return `${taskRoot}${queryString}`;
    }
    return {
        tasks: {
            root: taskRoot,
            console: `${taskRoot}/console`,
            rootForSpace: (spaceId: string | null) => {
                const hasTaskViewInCurrentSpace = session.currentPermissions.scopeToSpace(spaceId).hasPermissionInAnyScope(Permission.TaskView);
                const shouldFilterToCurrentSpace = spaceId && hasTaskViewInCurrentSpace;
                const includeSystem = !shouldFilterToCurrentSpace;
                return filteredTasks({
                    includeSystem,
                    spaces: shouldFilterToCurrentSpace ? [spaceId] : [],
                });
            },
            filtered: filteredTasks,
        },
        task: (taskId: string | TaskResource<any> | DeploymentResource) => {
            if (!!taskId && typeof taskId !== "string") {
                taskId = isDeploymentResource(taskId) ? taskId.TaskId : taskId.Id;
            }
            return {
                root: `${taskRoot}/${taskId}`,
                raw: `${taskRoot}/${taskId}/raw`,
            };
        },
    };
};

function isDeploymentResource(resource: TaskResource<any> | DeploymentResource): resource is DeploymentResource {
    return !!(resource as DeploymentResource).TaskId;
}
